import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext,} from 'react'
import {Link, useLocation} from 'react-router-dom'
import WorkspaceContext from "../WorkspaceContext";
import {formatNumber} from "../../../helpers/number";
import {Avatar} from "antd";
import {DepartmentActionTypes} from "../Host/WorkspaceMembers";
import {useOrganizationDepartmentForm} from "../../AppLocals/Organization/functions/useOrganizationDepartmentForm";
import {PiUsersFourLight, PiUsersThreeLight} from "react-icons/pi";

const StatCard = ({title, value, color, icon, style, href}) => (
    <Link to={href}
        style={style}
        className="px-4 py-3 flex items-center justify-between border border-color-100 background shadow-md rounded-xl no-underline cursor-pointer">
        <div className="flex flex-col flex-1">
            <p className="font-medium text-sm text-color-300 tracking-wider">{title}</p>
            <p className="mt-1 text-2xl font-bold text-gray-900 tracking-wide">{value || 0}</p>
        </div>
        <Avatar
            size={40}
            className={`flex flex-center bg-${color}-100`}
            icon={icon}
        />
    </Link>
);


const WorkspaceMemberDashboard = ({
                                      filter_actions = {
                                          sortBy: 'sort-by',
                                          keyword: 'keyword',
                                      },
                                  }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);

    const {
        modal,
        handleAction,
        onCancel,
    } = useOrganizationDepartmentForm({organization})


    return (
        <div className="flex flex-col flex-1 gap-y-3">
            <div className="flex flex-col gap-6">
                <h1 className="text-xl font-bold text-primary uppercase flex items-center">
                    {t("overview")}
                </h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <StatCard
                        title={t("total members")}
                        value={formatNumber(organization?.workspace_settings?.members?.statistics?.member_count)}
                        color="indigo" icon={<PiUsersThreeLight size={20} className="text-secondary"/>}
                        style={{
                            border: '1px solid var(--color-secondary-300)',
                            boxShadow: '0 2px 4px 0px var(--color-secondary-200)',
                        }}
                        href={`/workspace/member?rel=org-members`}
                    />
                    <StatCard
                        title={t("total groups")}
                        value={formatNumber(organization?.workspace_settings?.members?.statistics?.department_count)}
                        color="green" icon={<PiUsersFourLight size={20} className="text-green-500"/>}
                        style={{
                            border: '1px solid rgba(106, 187, 141, 1)',
                            boxShadow: '0 2px 4px 0px rgba(198, 246, 213, 1)',
                        }}
                        href={`/workspace/member?rel=org-departments`}
                    />
                </div>
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Quick Action: Create Course */}
                    <div
                        style={{
                            borderRight: '1px solid var(--border-color-50)',
                            boxShadow: 'rgba(0, 0, 0, 0.08) 0px -2px 6px -2px, rgba(0, 0, 0, 0.1) 0px 8px 12px -4px;'
                        }}
                        className="p-6 flex flex-col background rounded-xl shadow-lg border-l-4 border-indigo-500">
                        <h3 className="mb-3 flex items-center text-xl font-bold text-gray-800 tracking-wide">
                            <PiUsersFourLight size={20} className="mr-2 text-indigo-500"/>
                            {t("initialize group / ministry")}
                        </h3>
                        <p className="mb-4 text-color-300 tracking-wider">
                            {t("start setting up a new group or ministry in your organization.")}
                        </p>
                        <button
                            onClick={() => {
                                handleAction(DepartmentActionTypes.DEPT_CREATE)
                            }}
                            className="w-full px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-700 transition font-medium">
                            + {t("create new group / ministry")}
                        </button>
                    </div>

                </div>
            </div>
            {modal}
        </div>
    )
}


export default WorkspaceMemberDashboard
